import React, { useEffect } from "react";
import "../Styles/about.css";
import styled from "styled-components";
import fashion from "../Assets/Images/fashion.png";
import tailoring from "../Assets/Images/tailoring.png";
import laundry from "../Assets/Images/laundry.png";
import Components from "../Components/Styled/Components";

const StyledDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
`;

const About = () => {
  const { StyledParagraph } = Components;
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, [])

  return (
    <div className="about mx-auto">
      <div>
        <p className="fs-1 fw-bold text-center">About 2M Seamless</p>
        <p className="text-center mt-4 about-2mseamless">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </p>
        <div className="btn-container d-flex justify-content-center align-items-center gap-3 mt-4 pt-2 pt-sm-5">
          <button className="learn-more px-5 py-2">Learn More</button>
          <button className="contact-us px-5 py-2 ">Contact Us</button>
        </div>
      </div>
      <div className="mt-lg">
        <div className="fashion mt-5 pt-5">
          <StyledDiv className="styled d-flex flex-column d-md-grid">
            <div className="d-flex flex-column justify-content-center">
              <StyledParagraph>Fashion</StyledParagraph>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat.
              </p>
            </div>
            <div>
              <img src={fashion} alt="fashion" />
            </div>
          </StyledDiv>
          <StyledDiv className="styled tailoring d-flex flex-column d-md-grid mt-5 pt-5">
            <div className="order-2 d-flex flex-column justify-content-center">
              <StyledParagraph>Tailoring</StyledParagraph>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat.
              </p>
            </div>
            <div className="order-1 ">
              <img src={tailoring} alt="tailoring" />
            </div>
          </StyledDiv>
          <StyledDiv className="styled d-flex flex-column d-md-grid my-5 py-5">
            <div className="d-flex flex-column justify-content-center">
              <StyledParagraph>Laundry</StyledParagraph>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat.
              </p>
            </div>
            <div>
              <img className="laundry-img" src={laundry} alt="laundry" />
            </div>
          </StyledDiv>
        </div>
      </div>
    </div>
  );
};

export default About;
